<form [formGroup]="form">
  <div class="gap-lg grid" formArrayName="secteurs">
    @for (form of secteurs.controls; track $index; let idx = $index) {
      <div [formGroupName]="idx" hlmField>
        <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom du secteur d'activité {{ idx + 1 }}</label>
        <input [id]="'nom-' + idx" hlmInput type="text" formControlName="nom" />
        @if (form.get('nom')?.hasError('required') && form.touched) {
          <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
        }
        @if (form.get('nom')?.hasError('notUnique')) {
          <hlm-field-error>Ce secteur existe déjà.</hlm-field-error>
        }
      </div>
    }
    <app-button-add-new (click)="addSecteur()" label="Ajouter un autre secteur d'activité" />
  </div>
</form>
